export const baseUrl = process.env.NODE_ENV === 'production' 
? 'https://elevensimback.netlify.app/api'  // Replace with your actual backend URL
: '/api';